/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsNotificationChannelOverrideDtoSchema = z.object({
  eventType: z.string().nullish(),
  inApp: z.optional(z.boolean()),
  discord: z.optional(z.boolean()),
  email: z.optional(z.boolean()),
  soundForCritical: z.optional(z.boolean()),
});
